import { unavailableOnWeb } from './unavailableOnWeb.web';
/**
 * Web stub for `@react-native-google-signin/google-signin`.
 */
export const GoogleSignin = {
    configure: () => { },
    hasPlayServices: unavailableOnWeb('GoogleSignin.hasPlayServices'),
    signIn: unavailableOnWeb('GoogleSignin.signIn'),
    signOut: async () => null,
};
export const statusCodes = {
    SIGN_IN_CANCELLED: 'SIGN_IN_CANCELLED',
    IN_PROGRESS: 'IN_PROGRESS',
    PLAY_SERVICES_NOT_AVAILABLE: 'PLAY_SERVICES_NOT_AVAILABLE',
    SIGN_IN_REQUIRED: 'SIGN_IN_REQUIRED',
    NULL_PRESENTER: 'NULL_PRESENTER',
};
